<app-custom-table-header [data]="data" [isEditingAll]="isEditingAll" [showImportButton]="showImportButton"
    [showImportFileButton]="showImportFileButton" [isSettingsOpen]="isSettingsOpen" [columnsCopy]="columnsCopy"
    [schemaName]="schemaName" [tableVerticleView]="tableVerticleView" [enableSummary]="enableSummary"
    [enableAdjustment]="enableAdjustment" (settingsClicked)="openSettings()" (editClicked)="startEditAll()"
    (saveClicked)="saveAllEdits()" (cancelClicked)="cancelEditAll()" (searchClicked)="openImportModal()"
    (fileUploaded)="handleFileUpload($event)" (applySettingsClicked)="applySettings($event)"
    (settingsClosed)="isSettingsOpen = false" [showEnableSummary]="true" [showEnableAdjustment]="true" />


<ng-container *ngIf="isEditingAll" class="w-full">
    <div class="excel-formula-bar">
        <span class="fx-label">fx</span>
        <!-- (ngModelChange)="applyFormulaFromBar()" -->
        <input type="text" class="fx-input" [(ngModel)]="selectedCell.formula" (keydown.enter)="applyFormulaFromBar()"
            placeholder="Select a cell to edit formula" #formulaBar/>
        <button class="btn-icon cancel" (click)="clearSelectedCell()">✖</button>
        <button class="btn-icon apply" (click)="applyFormulaFromBar()">✔</button>
    </div>
</ng-container>


<ng-container >
    <app-google-maps [locationDetails]="locationCoordinates" [zoom]="6" *ngIf="showMap"></app-google-maps >

<div class="table-responsive" *ngIf="isVerticalTable && isAdjustive">
    <clr-datagrid>
        <clr-dg-column class="col-width">Fields</clr-dg-column>
        <clr-dg-column *ngIf="defaultData" class="col-width">Subject</clr-dg-column>
        <clr-dg-column *ngFor="let row of data; let i = index" class="col-width">
            <div class="d-flex justify-content-between w-full">
                <span>
                    {{ verticleTableHeaderTitle }} {{ i + 1 }}
                </span>
                <span>
                    Adjustments
                </span>
            </div>
        </clr-dg-column>
        <ng-container *ngIf="isEditingAll" class="col-width">
            <clr-dg-column *ngFor="let row of newRows; let i = index">
                <div class="d-flex justify-content-between w-full">
                    <span>
                        New {{ i + 1 }}
                    </span>
                    <span>
                        Adjustments
                    </span>
                </div>
            </clr-dg-column>
        </ng-container>
        <ng-container *ngFor="let group of groupedVisibleColumns | keyvalue">
            <clr-dg-row class="group-title-row non-data-row" *ngIf="group.key!=='General'">
                <clr-dg-cell [attr.colspan]="2 + data.length + (isEditingAll ? newRows.length : 0)"
                    class="header-title w-auto">
                    {{ group.key }}
                </clr-dg-cell>
            </clr-dg-row>


            <ng-container *ngFor="let col of group.value; let colIndex = index">
                <clr-dg-row *ngIf="(col.visible === true || col.visible === 'true') && !col.is_summary">
                    <clr-dg-cell class="col-width" (click)="copyToClipboard(col.field)">
                        <div class="d-flex justify-content-between">
                            <span>
                                {{ col.name }}
                            </span>
                            <span class="clipboard-copy" *ngIf="isEditingAll">
                                <clr-icon shape="copy"></clr-icon>
                            </span>
                        </div>
                    </clr-dg-cell>

                    <clr-dg-cell *ngIf="defaultData && objectKeys(defaultData).length" class="col-width">
                        <ng-container *ngIf="col.unit !== 'custom'; else customCell">
                            <span style="display: flex; justify-content: space-between; width: 100%;">
                                <span>{{ getDisplayValue(defaultData, col) }}</span>
                            </span>
                        </ng-container>
                        <ng-template #customCell>
                            <div [innerHTML]="renderCell({ field: col.field, data: defaultData })"></div>
                        </ng-template>

                    </clr-dg-cell>

                    <ng-container *ngIf="data && data.length > 0">
                        <clr-dg-cell *ngFor="let row of data; let rowIndex = index" class="col-width">
                            <!-- while editing -->
                            <ng-container *ngIf="isEditingAll; else displayMode">
                                <!-- *ngIf="!col.formula && !row.formulas?.[col.field];else formulaDriven" -->
                                <div class="d-flex justify-content-between">
                                    <div [ngSwitch]="col.type">
                                        <select *ngSwitchCase="'boolean'" [(ngModel)]="row[col.field]" class="clr-input"
                                            (ngModelChange)="validateField(col.field, col.type,rowIndex,row)">
                                            <option [value]="true">True</option>
                                            <option [value]="false">False</option>
                                        </select>
                                        <textarea *ngSwitchCase="'custom'" [(ngModel)]="row[col.field]"
                                            class="clr-input"
                                            (ngModelChange)="validateField(col.field, col.type,rowIndex,row)">
                                        </textarea>
                                        <select *ngSwitchCase="'select'" [(ngModel)]="row[col.field]" class="clr-input"
                                            (ngModelChange)="validateField(col.field, col.type,rowIndex,row)">
                                            <option *ngFor="let option of col.options" [value]="option.value">{{
                                                option.label }}
                                            </option>
                                        </select>
                                        <input *ngSwitchCase="'number'" [(ngModel)]="row[col.field]"
                                            [type]="col.type || 'text'" class="clr-input" min=0
                                            (ngModelChange)="validateField(col.field, col.type,rowIndex,row)" />
                                        <input *ngSwitchDefault [(ngModel)]="row[col.field]" [type]="col.type || 'text'"
                                            class="clr-input"
                                            (ngModelChange)="validateField(col.field, col.type,rowIndex,row)" />
                                    </div>
                                    <div>
                                        <input class="excel-cell-input formula-driven"
                                            [value]="row?.adjustments?.[col?.field ?? ''] ?? null" readonly
                                            (focus)="selectCell(rowIndex, col)" />
                                    </div>
                                </div>
                                <div *ngIf="errors[rowIndex] && errors[rowIndex][col.field]" class="text-danger">
                                    {{ errors[rowIndex][col.field] }}
                                </div>
                            </ng-container>
                            <!-- non edit (default display mode) -->
                            <ng-template #displayMode>
                                <ng-container *ngIf="col.unit !== 'custom'; else customCell">
                                    <span style="display: flex; justify-content: space-between; width: 100%;">
                                        <span class="display-cell">{{ getDisplayValue(row, col)}} </span>
                                        <ng-container
                                            *ngIf="(col.enable_adjustment === true || col.enable_adjustment === 'true' || row.formulas?.[col.field])">
                                            <!-- <input class="clr-input" type="text"
                                                [ngStyle]="{ color: row[col.adjustmentField] < 0 ? 'red' : 'green' }"
                                                [(ngModel)]="row[col.field]" (focus)="selectCell(rowIndex, col)"
                                                *ngIf="isEditingAll" /> -->
                                            <!-- (ngModelChange)="onAdjustmentChange(rowIndex, col)" -->
                                            <span
                                                [ngStyle]="{ color: row?.adjustments?.[col?.field]  < 0 ? 'red' : 'green' }">
                                                {{getDisplayValue(row, col, true)}}</span>
                                        </ng-container>

                                    </span>
                                </ng-container>
                                <ng-template #customCell>
                                    <div [innerHTML]="renderCell({ field: col.field, data: row })"></div>
                                </ng-template>
                            </ng-template>
                        </clr-dg-cell>
                    </ng-container>
                    <!-- new rows -->
                    <ng-container *ngFor="let row of newRows; let rowIndex = index">
                        <clr-dg-cell *ngIf="isEditingAll && col.visible" class="col-width">
                            <div class="d-flex justify-content-between">
                                <div [ngSwitch]="col.type">
                                    <select *ngSwitchCase="'boolean'" [(ngModel)]="row[col.field]" class="clr-input"
                                        (blur)="onFieldBlur(col.field, col.type, rowIndex, row)">
                                        <option [value]="true">True</option>
                                        <option [value]="false">False</option>
                                    </select>

                                    <textarea *ngSwitchCase="'custom'" [(ngModel)]="row[col.field]" class="clr-input"
                                        (blur)="onFieldBlur(col.field, col.type, rowIndex, row)">
                                    </textarea>

                                    <select *ngSwitchCase="'select'" [(ngModel)]="row[col.field]" class="clr-input"
                                        (blur)="onFieldBlur(col.field, col.type, rowIndex, row)">
                                        <option *ngFor="let option of col.options" [value]="option.value">{{
                                            option.label }}
                                        </option>
                                    </select>

                                    <input *ngSwitchCase="'number'" [(ngModel)]="row[col.field]"
                                        [type]="col.type || 'text'" class="clr-input" min="0"
                                        (blur)="onFieldBlur(col.field, col.type, rowIndex, row)" />

                                    <input *ngSwitchDefault [(ngModel)]="row[col.field]" [type]="col.type || 'text'"
                                        class="clr-input" (blur)="onFieldBlur(col.field, col.type, rowIndex, row)" />
                                </div>
                                <div>
                                    <input class="excel-cell-input formula-driven"
                                        [value]="row?.adjustments?.[col?.field ?? ''] ?? null" readonly
                                        (focus)="selectCell(data.length + rowIndex, col)" />
                                </div>
                            </div>
                            <div *ngIf="errors?.newRows?.[rowIndex]?.[col.field]" class="text-danger">
                                {{ errors.newRows[rowIndex][col.field] }}
                            </div>
                        </clr-dg-cell>
                    </ng-container>

                </clr-dg-row>

                <clr-dg-row *ngIf="col.is_summary && enableAdjustment" class="summary">
                    <clr-dg-cell class="fw-bold">
                        {{ col.name }}
                    </clr-dg-cell>
                    <clr-dg-cell>

                    </clr-dg-cell>
                    <clr-dg-cell *ngFor="let row of data; let rowIndex = index" class="fw-bold">
                        <span style="display: flex; justify-content: space-between; width: 100%;">
                            <span>$0</span>
                            <ng-container *ngIf="col.enable_adjustment">
                                <span [ngStyle]="{ color: defaultData[col.adjustmentField] < 0 ? 'red' : 'green' }">
                                    (0%)
                                </span>
                            </ng-container>
                        </span>
                    </clr-dg-cell>
                </clr-dg-row>

                <clr-dg-row *ngIf="col.is_summary && enableSummary" class="summary">
                    <clr-dg-cell class="fw-bold">
                        Adjustment $/unit
                    </clr-dg-cell>
                    <clr-dg-cell>

                    </clr-dg-cell>
                    <clr-dg-cell *ngFor="let row of data; let rowIndex = index" class="fw-bold">
                        <span style="display: flex; justify-content: space-between; width: 100%;">
                            <span>$0</span>
                        </span>
                    </clr-dg-cell>
                </clr-dg-row>
            </ng-container>


        </ng-container>
        <clr-dg-row *ngIf="isEditingAll;">
            <!-- Matches the 'Fields' column -->
            <clr-dg-cell class="col-width">Actions</clr-dg-cell>

            <!-- Matches the 'Subject' column -->
            <clr-dg-cell *ngIf="defaultData && objectKeys(defaultData).length" class="col-width"></clr-dg-cell>

            <!-- Matches dynamic data columns -->
            <clr-dg-cell *ngFor="let row of data; let rowIndex = index" class="col-width">
                <clr-icon shape="trash" class="cursor-pointer text-danger" (click)="openDeleteModal(rowIndex)">
                </clr-icon>
            </clr-dg-cell>

            <!-- Matches dynamic newRows columns -->
            <clr-dg-cell *ngFor="let row of newRows; let colIndex = index" class="col-width">
                <clr-icon shape="trash" class="cursor-pointer text-danger ms-2" (click)="newRows.splice(colIndex, 1)">
                </clr-icon>
            </clr-dg-cell>
        </clr-dg-row>

    </clr-datagrid>

</div>

</ng-container>


<!-- Delete modal -->
<clr-modal [(clrModalOpen)]="isDeleteModalOpen">
    <h3 class="modal-title">Confirm Delete</h3>
    <div class="modal-body">
        <p>Are you sure you want to delete this data?</p>
    </div>
    <div class="modal-footer">
        <button class="btn btn-danger" (click)="confirmDelete()">Delete</button>
        <button class="btn btn-outline" (click)="isDeleteModalOpen = false">Cancel</button>
    </div>
</clr-modal>


<div class="setting-modal">

    <clr-modal [(clrModalOpen)]="isImportModalOpen" [clrModalSize]="'full-screen'">
        <h3 class="modal-title">Import Data</h3>
        <div class="modal-body">
            <app-custom-import-filters  *ngIf="isImportModalOpen" (closeModal)="closeImportModal()" [schemaName]="schemaName" 
                [columns]="columns"  (selectedPropertiesChange)="getSelectedComps($event)"
                [totalCount]="totalCount" [pageSize]="pageSize" [offset]="(currentPage - 1) * pageSize"
                (pageChange)="onPageChanged($event)" [onCellRender]="onCellRender" [propertyDetail]="propertyDetail"
                [selectedProperties]="this.selectedComps" (loadMore)="fetchMore()"></app-custom-import-filters>
        </div>
        <div class="modal-footer">
            <button class="btn btn-primary" (click)="addComparable()">Submit</button>
            <button class="btn btn-outline ms-2" (click)="closeImportModal()">Cancel</button>
        </div>
    </clr-modal>
</div>